import React from 'react'

import { func, node } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import Modal from 'Pods/Shared/Modal/Modal'

function ShareModal({ closeModal: handleCloseModal, content }) {
  return (
    <Modal
      header={i18n.t('share_modal.title', { ns: 'rails' })}
      onClose={handleCloseModal}
      width="medium"
      ariaLabel={i18n.t('share_modal.aria_label', { ns: 'rails' })}
      customClass="share-modal"
    >
      <div className="share-modal__content">
        {content}
      </div>
    </Modal>
  )
}

ShareModal.propTypes = {
  closeModal: func.isRequired,
  content: node.isRequired,
}

export default ShareModal
